var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.user().isTc)?_c('tc-edit',{ref:"patientEditComponent"}):(_vm.$auth.user().isRdkm)?_c('rdkm-edit',{ref:"patientEditComponent"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }